var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBugSidebarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bugs",
    d: "M411.725,420.294h-9a3,3,0,0,0-3,3v9a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3v-9A3,3,0,0,0,411.725,420.294Zm-6.061,2.741a2.2,2.2,0,0,1,3.766,1.561h-4.41A2.129,2.129,0,0,1,405.664,423.035Zm6.943,5.841a.425.425,0,0,1-.31.131h-1.544a4.027,4.027,0,0,1-.461,2l1.433,1.44a.434.434,0,0,1,0,.621.435.435,0,0,1-.62,0l-1.365-1.358a1.331,1.331,0,0,1-.1.09c-.046.036-.142.1-.289.2a4.438,4.438,0,0,1-.448.251,3.1,3.1,0,0,1-.565.2,2.594,2.594,0,0,1-.669.09V426.36h-.882v6.175a2.7,2.7,0,0,1-.7-.093,2.8,2.8,0,0,1-.6-.228c-.168-.089-.319-.179-.455-.268a2.683,2.683,0,0,1-.3-.224l-.1-.1-1.261,1.427a.444.444,0,0,1-.662-.593l1.392-1.564a4.128,4.128,0,0,1-.4-1.888h-1.544a.442.442,0,0,1,0-.883H403.7V426.1l-1.193-1.192a.439.439,0,1,1,.621-.62l1.192,1.192h5.816l1.192-1.192a.439.439,0,1,1,.621.62l-1.193,1.192v2.026H412.3a.439.439,0,0,1,.31.752Z",
    transform: "translate(-399.725 -420.294)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugSidebarImage);
export default __webpack_public_path__ + "static/media/Bug-sidebar-image.e7210128d9979097b05fdf7df959fc10.svg";
export { ForwardRef as ReactComponent };